const SM4 = require('./src/sm4')

module.exports = {
  sm4: SM4
}
